module.exports = __webpack_public_path__ + "static/img/mrowka.bca0c41e.jpg";